// Community Card Management APIs

/**
 * @function ApiClient#DeleteHouseHoldCard
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} params.cardID
 * @param {any} options = {}
 */
export async function DeleteHouseHoldCard(cid, { building, doorPlate, floor, cardID }, options = {}) {
  return await this._delete(`/community/${cid}/card?b=${building}&d=${doorPlate}&f=${floor}&c=${cardID}`, options);
}
